import { render } from "./InstallmentsList.vue?vue&type=template&id=12a4c099&scoped=true&ts=true"
import script from "./InstallmentsList.vue?vue&type=script&lang=ts"
export * from "./InstallmentsList.vue?vue&type=script&lang=ts"

import "./InstallmentsList.vue?vue&type=style&index=0&id=12a4c099&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a4c099"]])

export default __exports__